import React, { useState } from 'react'
import { Button } from 'components/elements'
import BannerFeedback from 'components/elements/bannerFeedback'
import AskQuestionToOwnerModal from './askQuestionToOwnerModal'
import MessageDeliveryConfirmationModal from './messageDeliveryConfirmationModal'
import { messageSentTracking } from 'components/elements/tracking/chatTracking'
import { apiProcess } from 'components/api/api'
import VerifyEmailPhoneModal from './verifyEmailPhoneModal'
import Skeleton from 'components/elements/skeletons/TempSkeleton'
import './../conversations.sass'

const getUserDetailedInfo = async () => {
  try {
    const response = await apiProcess(
      'users/detailed_info',
      null,
      'user-detailed-info'
    )
    return response.user
  } catch (err) {
    console.error(err)
    return null
  }
}

export const StartConversation = (props) => {
  const [isLoading, setIsLoading] = useState(false)
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [isMessageDeliveryModalOpen, setIsMessageDeliveryModalOpen] = useState(
    false
  )
  const [showError, setShowError] = useState(false)
  const [showSuccess, setShowSuccess] = useState(false)
  const [chatSessionUUID, setChatSessionUUID] = useState('')
  const [isVerificationModalOpen, setIsVerificationModalOpen] = useState(false)
  const [userVerificationInfo, setUserVerificationInfo] = useState({
    emailVerified: false,
    phoneVerified: false,
  })

  const handleModalClose = (closeFunc) => () => {
    closeFunc(false)
  }

  const {
    recipientName,
    recipientAvatar,
    context,
    isMobile,
    handlePhoneVerified,
  } = props

  const handleBtnClick = async () => {
    const { isAuth, openLogin, skipVerification } = props

    if (!isAuth) {
      return openLogin(
        (auth) => {
          if (
            (auth.userIsEmailVerified() && auth.userIsPhoneVerified()) ||
            skipVerification
          ) {
            return setIsModalOpen(true)
          }
          setUserVerificationInfo({
            emailVerified: auth.userIsEmailVerified(),
            phoneVerified: auth.userIsPhoneVerified(),
          })
          if (
            !(
              userVerificationInfo['emailVerified'] ||
              userVerificationInfo['phoneVerified']
            )
          ) {
            setIsVerificationModalOpen(true)
          }
        },
        false,
        'conversation'
      )
    }

    if (skipVerification) {
      return setIsModalOpen(true)
    }

    setIsLoading(true)
    const userDetailedInfo = await getUserDetailedInfo()
    setIsLoading(false)
    if (
      userDetailedInfo &&
      !(userDetailedInfo.phone_verified && userDetailedInfo.email_confirmed)
    ) {
      setUserVerificationInfo({
        emailVerified: userDetailedInfo.email_confirmed,
        phoneVerified: userDetailedInfo.phone_verified,
      })
      return setIsVerificationModalOpen(true)
    }

    setIsModalOpen(true)
  }

  const onSendMessage = (message, setSubmitting) => {
    const {
      ownerUUID,
      riderUUID,
      riderUserPrettyId,
      motorcycleUUID,
      requestUUID,
    } = props

    const apiURL = 'chat_sessions'

    apiProcess(
      apiURL,
      {
        message,
        motorcycle_uuid: motorcycleUUID,
        owner_uuid: ownerUUID,
        rider_uuid: riderUUID,
        rider_user_pretty_id: riderUserPrettyId,
        request_uuid: requestUUID,
      },
      'create-chat-session',
      ''
    )
      .then((responseData) => {
        messageSentTracking(riderUUID, ownerUUID, motorcycleUUID, message)
        setSubmitting(false)
        setIsModalOpen(false)
        setChatSessionUUID(responseData.uuid)
        if (context === 'motorcycle') {
          setIsMessageDeliveryModalOpen(true)
        } else {
          setShowSuccess(true)
        }
      })
      .catch((error) => {
        setShowError(true)
        setSubmitting(false)
        setIsModalOpen(false)
      })
  }

  const handleVerificationComplete = () => {
    setIsModalOpen(true)
  }

  return (
    <div className="mt-5">
      {isLoading && <Skeleton />}
      <BannerFeedback
        showMessage={showSuccess}
        messageContent="Your message has been sent."
        messageType="success"
        onDismiss={() => setShowSuccess(false)}
      />
      <Button
        loading={false}
        className={`${isMobile ? 'is-fullwidth' : ''} question-button`}
        onClick={handleBtnClick}
      >
        {props.isPartner === true
          ? 'Ask a Question'
          : 'Ask ' + recipientName + ' a Question'}
      </Button>
      <MessageDeliveryConfirmationModal
        isModalOpen={isMessageDeliveryModalOpen}
        handleModalClose={handleModalClose(setIsMessageDeliveryModalOpen)}
        recipientName={recipientName}
        chatSessionUUID={chatSessionUUID}
      />
      <AskQuestionToOwnerModal
        isModalOpen={isModalOpen}
        handleModalClose={handleModalClose(setIsModalOpen)}
        recipientName={recipientName}
        recipientAvatar={recipientAvatar}
        onSendMessage={onSendMessage}
        showError={showError}
        setShowError={setShowError}
      />

      {isVerificationModalOpen && (
        <VerifyEmailPhoneModal
          isVerificationModalOpen={isVerificationModalOpen}
          handleModalClose={handleModalClose(setIsVerificationModalOpen)}
          isMobile={isMobile}
          userVerificationInfo={userVerificationInfo}
          handlePhoneVerified={handlePhoneVerified}
          onComplete={handleVerificationComplete}
        />
      )}
    </div>
  )
}

export default StartConversation
